export default {
    setCategorias(state, cat) {
        state.categorias = cat;
    },
    setProdActiveCat(state, prd) {
        state.prodActiveCat.productos = prd;
    },
    setCaracteristicas(state, c) {
        state.caracteristicas = c;
    },
    setCocinas(state, c) {
        state.cocinas = c;
    },
    setImpuestos(state, i) {
        state.impuestos = i;
    },
    setDescuentos(state, d) {
        state.descuentos = d;
    },
    emptyProdRest(state) {
        state.allProductos = [];
    },
    addProdRest(state, prd) {
        state.allProductos.push(prd.prod);
    },
    addProdRestSinCat(state, prd) {
        state.AllProductosSinCategoria = prd
    },
    setProdBartolome(state, prod) {
        state.allProductosBartolome = prod;
    },
    setLoadingProd(state, value) {
        state.prodActiveCat.loading = value;
    },
    setLoadingRest(state, val) {
        state.loadingRest = val;
    },
    setNumProd(state, { num, id_prd }) {
        let array = state.prodActiveCat.productos;
        for (var i in array) {
            if (array[i].id == id_prd) {
                array[i].cantidad = num;
                break; //Stop this loop, we found it!
            }
        }
    },


    setRestaurantesPosibles(state, data) {
        state.restaurantesPosibles = data;
    },
    setNegocio(state, n) {
        state.activeNegocio = n;
    },
    setNegocioObj(state, d) {
        state.activeNegocioObj = d;
    },
    /*resetRestauranteActivo(state) {
        state.activeRest = null;
        state.activeNegocio = null;
        state.activeNegocioObj = {
            imagenListado: "",
            nombre: "",
            imagen: ""
        };
        state.activeRestObj = {};
        localStorage.removeItem('activeRestId');
    },*/
    resetRestaurante(state) {
        // state.activeRest = null;
        // state.activeNegocio = null;
        // state.activeNegocioObj = {
        //     imagenListado:"",
        //     nombre:"",
        //     imagen:""
        // };
        // state.activeRestObj = null;
        state.allProductos = [];
        state.restaurantesPosibles = []; //es posible que sea el mismo que el de abajo, comprobar

        state.listadoNegocios = [];
        // localStorage.removeItem('activeRestId');

    },
    resetListadoRestaurante(state) {
        state.listadoRestaurantes = [];
    },
    setOpciones(state, data) {
        state.prodActiveCat.opciones = data;
    },

    setListadoRestaurantes(state, data) {
        state.listadoRestaurantes = [];
        state.listadoRestaurantes = data;
    },
    setListadoNegocios(state, data) {
        state.listadoNegocios = data;
    },
    setListadoRestNegMix(state, data) {
        state.listadoRestNegMix = data;
    },
    setDistanciasRestaurantes(state, data) {
        state.distanciasRestaurantes = data;
    },
    setAllProducts(state, data) {
        state.allProductos = data;
    },
    setCategoriasFiltradas(state, data) {
        state.categoriasFiltradas = data;
    },
    resetCategorias(state) {
        state.categorias = [];
    },
    resetAllProducts(state) {
        state.allProductos = [];
    }
}